module.exports = __webpack_public_path__ + "img/gongye-1.42556d63.jpg";